<template>
  <div class="content-box">
    <div class="login-box">
      <div class="left-box">
        <div class="login-content">
          <div class="login-txt">登录立即参赛</div>
          <div class="login-txt-desc">请输入手机号和密码登录</div>
          <div class="input-item">
            <div class="item-required">*</div>
            <div class="item-label">账&nbsp;&nbsp;&nbsp;号</div>
            <div class="item-input"><input type="text" placeholder="输入名称/电话/邮箱" autocomplete="new-userName" v-model="userName"></div>
          </div>
          <div class="input-item">
            <div class="item-required">*</div>
            <div class="item-label">密&nbsp;&nbsp;&nbsp;码</div>
            <div class="item-input"><input type="password" placeholder="请输入密码" autocomplete="new-password" v-model="password"></div>
          </div>
          <div class="input-item">
            <div class="item-required">*</div>
            <div class="item-label">验证码</div>
            <div class="item-input">
              <input type="text" class="code" placeholder="请输入验证码" content="off" v-model="code">
              <img class="code-img" :src="code_image" @click="restCodeImage()">
            </div>
          </div>
          <div class="protocol-box">
            <div class="protocol-checkbox">
              <img src="@/assets/checkbox_unselect.png" @click="checkRule()" :class="{'selected':!isCheckRule}">
              <img src="@/assets/checkbox_selected.png" @click="checkRule()" :class="{'selected':isCheckRule}">
              <span @click="checkRule()"> 我已阅读并同意</span>
              <span  class="protocol-txt" @click="goProtocol()">《比赛协议》</span>
            </div>
          </div>
          <div class="btn-login" @click="submitLogin()">登&nbsp;&nbsp;&nbsp;录</div>
          <div class="btn-other">
            <div class="save-pwd" @click="checkPwd()">
              <img src="@/assets/checkbox_unselect.png" :class="{'selected':!isCheckPwd}">
              <img src="@/assets/checkbox_selected.png" :class="{'selected':isCheckPwd}">
              <span> 记住密码</span>
            </div>
            <div class="forget-pwd" @click="goRest()">忘记密码了？</div>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="right-box-txt-zh">欢迎参赛</div>
        <div class="right-box-txt-en">Welcome to the</div>
        <div class="right-box-txt-en">CHINA BRAND DESIGN AWARDS!</div>
        <div class="right-box-txt-account">还没有账号？</div>
        <div class="btn-go-reg" @click="goRegister()">创建账号</div>
      </div>
    </div>
  </div>
</template>

<script>
//import moduleTop from "@/components/moduleTop";
//import ruleEl from "@/components/ruleEl";
import {Warning} from "@/plugins/warning";
import {userLogin,getImageCode} from "@/request/api";
import md5 from 'js-md5';
export default {
  name: "login",
  components:{
    //moduleTop,
    //ruleEl
  },
  data() {
    return {
      isCheckRule: true,
      isCheckPwd: false,
      userName: '',
      password: '',
      code: '',
      uuid: '',
      code_image: '',
    }
  },
  computed: {},
  created() {
    this.userName = localStorage.getItem('username');
    this.password = localStorage.getItem('password');
    let requestData = {};
    getImageCode(requestData).then((res)=>{
      this.code_image = "data:image/png;base64,"+res.data.code;
      this.uuid = res.data.uuid;
    })
  },
  mounted() {
  },
  methods: {
    toAbout(){
      this.$router.push({name:'About'})
    },
    submitLogin(){
      const {userName,password,uuid,code,isCheckRule,isCheckPwd} = this;
      if(!userName){
        Warning.open('请输入电话/邮箱')
        return false
      }
      if(!password){
        Warning.open('请输入密码!')
        return false
      }
      if(!code){
        Warning.open('请输入验证码!')
        return false
      }

      if(!isCheckRule){
        Warning.open('请阅读并同意《比赛协议》!')
        return false
      }
      if(isCheckPwd){
        localStorage.setItem('username', userName)
        localStorage.setItem('password', password)
      }else{
        localStorage.removeItem('username');
        localStorage.removeItem('password');
      }
      const requestData = {
        username:userName,
        password:md5(password),
        uuid:uuid,
        code:code
      }
      userLogin(requestData).then((res)=>{
        this.$store.commit('infoModule/updateToken',res.data.token);
        Warning.success('登录成功，即将跳转首页')
        setTimeout(()=>{
          this.$router.push({name:'userAccountManage'})
        },2500)
      })
    },
    goRest(){
      this.$router.push({name:'rest'})
    },
    goRegister(){
      this.$router.push({name:'userRegisterIndex'})
    },
    checkPwd(){
      this.isCheckPwd = !this.isCheckPwd;
    },
    checkRule(){
      this.isCheckRule = !this.isCheckRule;
    },
    goProtocol(){

    },
    restCodeImage(){
      let requestData = {};
      getImageCode(requestData).then((res)=>{
        this.code_image = "data:image/png;base64,"+res.data.code;
        this.uuid = res.data.uuid;
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.content-box{
  width: 1440px;
  height: 925px;
  overflow: hidden;
  background: url(~@/assets/login_background.png);
  background-size: cover;
  .login-box{
    width: 936px;
    height: 537px;
    margin-top: 150px;
    margin-left: auto;
    margin-right: auto;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    .left-box{
      width: 536px;
      height: 100%;
      float: left;
      background-color: rgba(255, 255, 255, 0.8);
      .login-content{
        width: 300px;
        height: 350px;
        margin-left: 115px;
        margin-top: 80px;
        .login-txt{
          font-size: 24px;
          font-weight: 400;
          color: #3F3F3F;
        }
        .login-txt-desc{
          font-size: 14px;
          font-weight: 400;
          color: #939393;
          margin-bottom: 30px;
        }
        .input-item {
          height: 33px;
          font-size: 14px;
          margin-bottom: 25px;
          clear: left;
          .item-required{
            float: left;
            color: #FF3B30;
            height: 33px;
            line-height: 33px;
          }
          .item-label{
            float: left;
            height: 33px;
            width: 55px;
            line-height: 33px;
          }
          .item-input{
            float: left;
            height: 33px;
            width: 221px;
            border-radius: 4px;
            border: 1px solid #ccc;
            & > input {
              width: 100%;
              height: 33px;
              line-height: 33px;
              font-size: 12px;
              background: transparent;
              padding-left: 10px;
              padding-right: 10px;
              border: none;
              outline: none;
              &:-webkit-autofill,
              &:-webkit-autofill:hover,
              &:-webkit-autofill:focus,
              &:-webkit-autofill:active {
                -webkit-box-shadow: 0 0 0 30px transparent inset !important;
                box-shadow: 0 0 0 30px transparent inset !important;
                background-color: transparent !important;
                background-image: none !important;
                transition: background-color 5000s ease-in-out 0s;
              }
            }
            .code{
              width: 120px;
              float: left;
            }
            .code-img{
              height: 28px;
              float: right;
            }
          }
        }
        .protocol-box{
          margin-left: 65px;
          margin-top: 30px;
          .protocol-checkbox{
            display: flex;
            align-items: center;
            color: #696969;
            cursor: pointer;
            img{
              width: 12px;
              height: 12px;
              float: left;
              display: none;
              margin-right: 8px;
            }
            span{
              float: left;
              font-size: 10px;
            }
            .selected{
              display: block;
            }
          }
        }
        .btn-login{
          width: 221px;
          height: 33px;
          line-height: 33px;
          margin-top: 15px;
          font-size: 12px;
          text-align: center;
          margin-left: 65px;
          color: #FFFFFF;
          cursor: pointer;
          border-radius: 4px;
          background: #FF3B30;
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
        }
        .btn-other{
          width: 221px;
          height: 33px;
          margin-top: 15px;
          margin-left: 65px;
          color: #696969;
          font-size: 12px;
          .save-pwd{
            display: flex;
            align-items: center;
            float: left;
            cursor: pointer;
            img{
              width: 12px;
              height: 12px;
              float: left;
              display: none;
              margin-right: 8px;
            }
            span{
              float: left;
            }
            .selected{
              display: block;
            }
          }
          .forget-pwd{
            float: right;
            cursor: pointer;
          }
        }
      }
    }
    .right-box{
      width: 400px;
      height: 100%;
      float: left;
      background: #FF3B30;
      .right-box-txt-zh{
        font-size: 24px;
        color: #FFFFFF;
        font-weight: 350;
        margin-left: 55px;
        margin-top: 130px;
      }
      .right-box-txt-en{
        font-size: 16px;
        color: #FFFFFF;
        font-weight: 350;
        font-style: italic;
        margin-left: 55px;
      }
      .right-box-txt-account{
        font-size: 14px;
        color: #FFFFFF;
        margin-left: 55px;
        margin-top: 15px;
      }
      .btn-go-reg{
        width: 190px;
        height: 33px;
        cursor: pointer;
        margin-left: auto;
        margin-right: auto;
        margin-top: 25px;
        line-height: 33px;
        border-radius: 3px;
        text-align: center;
        font-size: 12px;
        color: #FF3B30;
        background: #FFFFFF;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>
